import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Intent, Tag } from '@blueprintjs/core';

export default class extends PureComponent {
  static propTypes = {
    status: PropTypes.object,
    removed: PropTypes.bool,
    round: PropTypes.bool,
  };

  static defaultProps = {
    round: true,
  };

  render() {
    const { status = {}, removed, ...restProps } = this.props;
    const { queued, running, error } = status;

    if (removed) {
      return (
        <Tag {...restProps} intent={Intent.NONE}>
          Removed
        </Tag>
      );
    }

    if (queued === 0 && running === 0) {
      if (error > 0) {
        return (
          <Tag {...restProps} intent={Intent.DANGER}>
            Finished with errors
          </Tag>
        );
      }

      return (
        <Tag {...restProps} intent={Intent.SUCCESS}>
          Completed
        </Tag>
      );
    }

    if (running > 0) {
      return (
        <Tag {...restProps} intent={Intent.WARNING}>
          Running
        </Tag>
      );
    }

    return (
      <Tag {...restProps} intent={Intent.PRIMARY}>
        Queued
      </Tag>
    );
  }
}
